// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { connect } from 'react-redux'
import { logOut } from 'helpers/auth'
import Versions from './Versions'
import comsearchLogo from 'images/comsearch-logo-small.png'
import UserAnalysisStatuses from './UserAnalysisStatuses'

// intractiveSolutionsLink is a URL which will link the user back to the legacy application

const Menu = ({ intractiveSolutionsLink }) => (
  <>
    <UserAnalysisStatuses />
    <a
      href={intractiveSolutionsLink}
      id={'user-menu-interactive-solutions'}
      rel={'noopener noreferrer'}
      target={'_blank'}>
      <img
        alt={'comsearch logo'}
        src={comsearchLogo} />
      {'Interactive Solutions'}
    </a>
    <a
      href={'#'}
      id={'user-menu-logout'}
      onClick={logOut}>
      <i className={'fa fa-user-o'} />
      <span>{'Log-out'}</span>
    </a>
    <Versions key={'application-versions-container'}/>
  </>
)

Menu.propTypes = {
  intractiveSolutionsLink: string,
}

const mapStateToProps = ({ applicationSettings }) => ({
  intractiveSolutionsLink: applicationSettings.get('intractiveSolutionsLink'),
})

export default connect(
  mapStateToProps,
)(Menu)
